import React, { useState, useEffect } from "react";

const EditLocationForm = ({ department, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    department_name: department.department_name,
    department_code: department.department_code,
    description: department.description || ""
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit updated data
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/api/departments/update-department/${department.department_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to update department.");
      }

      const updatedDepartment = { ...department, ...formData };

      onSave(updatedDepartment); // Update parent state & refresh list
      onClose(); // Close modal
    } catch (error) {
      console.error("Error updating department:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3>Edit department</h3>
        <form onSubmit={handleSubmit}>
          <label>Department Code:</label>
          <input type="text" id='edit-user-firstname' name="department_code" value={formData.department_code} onChange={handleChange}/>

          <label>Department Name:</label>
          <input type="text" id='edit-user-firstname' name="department_name" value={formData.department_name} onChange={handleChange} required />

          <label>description:</label>
          <input type="text" id='edit-user-firstname' name="description" value={formData.description} onChange={handleChange}/>

          <button type="submit" className="save-button">Save Changes</button>
        </form>
      </div>
    </div>
  );
};

export default EditLocationForm;
